import Vue from 'vue'

export const EventBus = new Vue()

export const GlobalEvents = {
  reviews_showAddReviewForm: 'reviews:showAddReviewForm',
  reviews_processingChanged: 'reviews:processing',
  myAccountReviews_showAddReviewForm: 'myAccountReviews:showAddReviewForm',
  myAccountReviews_reloadReviews: 'myAccountReviews:reloadReviews'
}



// WEBPACK FOOTER //
// ./src/shared/eventBus.js